/**
 * Registry of experimental features.
 *
 * An experimental feature is code that ships in the app but is switched off
 * for everyone — except inside the platform test environment, where a
 * platform admin can flip it on and off (from the Test Environment tab or
 * the sandbox bar) to try it as any test account.
 *
 * To add one:
 *   1. Add an entry here. The key is what the switch is stored under.
 *   2. Gate the UI with <ExperimentalFeature feature="my-key"> or
 *      useExperimental().isEnabled("my-key") — both are always false for
 *      regular users, with no Firestore read.
 *   3. (Optional) gate a Cloud Function with
 *      isExperimentalFeatureEnabled(request.auth, "my-key") from
 *      functions/lib/experimentalFeatures.js.
 *
 * When the feature is ready for everyone, remove the gate and the entry.
 */
export interface ExperimentalFeature {
  /** Stable identifier: lowercase letters, digits and dashes. */
  key: string;
  name: string;
  description: string;
  /** Where a tester will notice it, shown as a hint in the toggle list. */
  area: "Officers" | "Agency admins" | "Organization portal" | "Everyone";
}

/** Agency invoicing: invoice manager, invoice settings, PDF template designer, and the organization portal's invoice pages. */
export const FEATURE_AGENCY_INVOICING = "agency-invoicing";

export const EXPERIMENTAL_FEATURES: ExperimentalFeature[] = [
  {
    key: FEATURE_AGENCY_INVOICING,
    name: "Agency invoicing & PDF invoice designer",
    description: "Invoices tab and Invoice Settings in the Jobs hub, the Invoice Template designer, per-organization invoice PDFs, 'Generate Invoice' on requests and completed jobs, and the Invoices page in the organization portal. Still being built.",
    area: "Everyone",
  },
];

export const EXPERIMENTAL_FEATURE_KEY_PATTERN = /^[a-z][a-z0-9-]{1,40}$/;
